import { CloseOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { useIsMobileView } from "../../hooks/ui-hook";
import { LC_KEYS } from "../../utils/constants";

const ExtensionBanner: React.FC = () => {
  const [showExtensionBanner, setShowExtensionBanner] = useState<boolean>(false);

  const isMobile = useIsMobileView();

  useEffect(() => {
    const hideExtensionBanner = localStorage.getItem(LC_KEYS.HIDE_EXTENSION_BANNER);
    if (hideExtensionBanner === "true") {
      setShowExtensionBanner(false);
    } else {
      setShowExtensionBanner(true);
    }
  }, []);

  const hideExtension = () => {
    localStorage.setItem(LC_KEYS.HIDE_EXTENSION_BANNER, "true");
    setShowExtensionBanner(false);
  };

  if (!showExtensionBanner || isMobile) return null;

  return (
    <div
      style={{
        background: "rgb(90 88 235)",
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "5px 20px",
        color: "#fff",
        fontSize: 14,
        fontWeight: 500,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <span
          style={{
            background: "#8f9cf7",
            color: "#fff",
            borderRadius: 16,
            padding: "4px 14px",
            fontWeight: 700,
            fontSize: 14,
            marginRight: 8,
          }}
        >
          NEW
        </span>
        <span>
          One-click note transfer into TherapyNotes, CharmHealth, AdvancedMD & 15+ EHRs. Setup in under 2 minutes.
        </span>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        <a
          onClick={hideExtension}
          href="https://chromewebstore.google.com/detail/khnjmojbacjmfbplefmcinlmlbifhjnj?utm_source=item-share-cb"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "flex",
            alignItems: "center",
            background: "#fff",
            color: "#5d5ded",
            borderRadius: 5,
            padding: "5px 10px",
            fontWeight: 600,
            fontSize: 14,
            textDecoration: "none",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          }}
        >
          <img
            src="https://www.google.com/chrome/static/images/chrome-logo.svg"
            alt="Chrome"
            style={{ width: 14, height: 14, marginRight: 8 }}
          />
          Install Chrome Extension
        </a>
        <button
          onClick={hideExtension}
          style={{
            background: "#6a6af6",
            color: "#fff",
            border: "none",
            borderRadius: "50%",
            width: 24,
            height: 24,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            fontSize: 12,
            cursor: "pointer",
          }}
        >
          <CloseOutlined />
        </button>
      </div>
    </div>
  );
};

export default ExtensionBanner;
